import { useEffect } from 'react';
import { useTaskStore } from '../store/taskStore';
import { TaskFilter } from '../types';
import TaskCard from './TaskCard';
import NewTaskForm from './NewTaskForm';
import { Plus, Filter } from 'lucide-react';

export default function TaskList() {
  const { tasks, filter, loading, fetchTasks, setFilter, selectedTask, setSelectedTask } = useTaskStore();

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  // Filter tasks based on current filter
  const filteredTasks = tasks.filter(task => {
    if (filter === 'active') return !task.completed;
    if (filter === 'completed') return task.completed;
    return true;
  });

  const handleFilterChange = (newFilter: TaskFilter) => {
    setFilter(newFilter);
  };

  const handleNewTask = () => {
    setSelectedTask(null);
    // We'll use a modal state in the parent or here
  };

  if (loading && tasks.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header with filters */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Filter className="w-5 h-5 text-soft-muted" />
          <div className="flex gap-2">
            <button
              onClick={() => handleFilterChange('all')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                filter === 'all'
                  ? 'bg-primary-500 text-white'
                  : 'bg-white text-soft-text hover:bg-gray-50'
              }`}
            >
              Tümü ({tasks.length})
            </button>
            <button
              onClick={() => handleFilterChange('active')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                filter === 'active'
                  ? 'bg-primary-500 text-white'
                  : 'bg-white text-soft-text hover:bg-gray-50'
              }`}
            >
              Aktif ({tasks.filter(t => !t.completed).length})
            </button>
            <button
              onClick={() => handleFilterChange('completed')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                filter === 'completed'
                  ? 'bg-primary-500 text-white'
                  : 'bg-white text-soft-text hover:bg-gray-50'
              }`}
            >
              Tamamlanan ({tasks.filter(t => t.completed).length})
            </button>
          </div>
        </div>
      </div>

      {/* Task list */}
      {filteredTasks.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-soft shadow-soft">
          <p className="text-soft-muted text-lg">
            {filter === 'all' && 'Henüz görev yok. Yeni bir görev ekleyin!'}
            {filter === 'active' && 'Aktif görev yok.'}
            {filter === 'completed' && 'Tamamlanmış görev yok.'}
          </p>
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {filteredTasks.map((task, index) => (
            <div
              key={task.id}
              className="animate-fade-in"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <TaskCard task={task} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
